import { SafetyCenter } from '@/screens/safety-center';

export default function SafetyCenterRoute() {
  return <SafetyCenter />;
}
